(() => {
  const STORAGE_KEY = 'hmns_recently_viewed';

  const initSwiper = (swiperEl, store) => {
    if (!swiperEl || typeof Swiper === 'undefined') return null;

    if (window.innerWidth <= 998) {
      if (!store.instance || store.instance.destroyed) {
        store.instance = new Swiper(swiperEl, {
          slidesPerView: 1.8,
          spaceBetween: 20,
          slidesOffsetAfter: 20,
          grabCursor: true,
          breakpoints: {
            0: {
              slidesPerView: 1.8,
              spaceBetween: 20,
              slidesOffsetAfter: 20,
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
              slidesOffsetAfter: 20,
            },
          },
        });
      } else {
        store.instance.update();
      }
      return store.instance;
    }

    if (store.instance && !store.instance.destroyed) {
      store.instance.destroy(true, true);
      store.instance = null;
    }
    return null;
  };

  const mountSection = (root) => {
    if (!root || root.dataset.relatedTabsInit === 'true') return;
    root.dataset.relatedTabsInit = 'true';

    const tabs = Array.from(root.querySelectorAll('[data-related-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-related-panel]'));
    const recSwiperEl = root.querySelector('[data-related-swiper="recommendations"]');
    const rvSwiperEl = root.querySelector('[data-related-swiper="recently-viewed"]');
    const recGrid = root.querySelector('[data-related-grid="recommendations"]');
    const rvGrid = root.querySelector('[data-related-grid="recently-viewed"]');
    const recUrl = root.dataset.recUrl;
    const currentHandle = root.dataset.currentProductHandle;
    const rvLimit = Number(root.dataset.rvLimit) || 4;

    const swipers = {
      recommendations: { instance: null },
      'recently-viewed': { instance: null },
    };

    const activateTab = (key) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.relatedTab === key;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        const active = panel.dataset.relatedPanel === key;
        panel.classList.toggle('is-active', active);
        if (active) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      requestAnimationFrame(() => {
        if (key === 'recommendations') initSwiper(recSwiperEl, swipers.recommendations);
        if (key === 'recently-viewed') initSwiper(rvSwiperEl, swipers['recently-viewed']);
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        activateTab(tab.dataset.relatedTab);
      });
    });

    const loadRecommendations = () => {
      if (!recUrl || !recGrid) return;

      fetch(recUrl)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const nextGrid = html.querySelector('[data-related-grid="recommendations"]');
          if (!nextGrid || !nextGrid.innerHTML.trim()) return;

          if (swipers.recommendations.instance && !swipers.recommendations.instance.destroyed) {
            swipers.recommendations.instance.destroy(true, true);
            swipers.recommendations.instance = null;
          }

          recGrid.innerHTML = nextGrid.innerHTML;
          initSwiper(recSwiperEl, swipers.recommendations);
        })
        .catch(() => {});
    };

    const loadRecentlyViewed = () => {
      if (!rvGrid) return;

      let viewedList = [];
      try {
        viewedList = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      } catch (e) {
        viewedList = [];
      }

      viewedList = viewedList.filter((handle) => handle && handle !== currentHandle);

      if (currentHandle) {
        const updatedList = [currentHandle, ...viewedList].slice(0, 10);
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedList));
        } catch (e) {}
      }

      if (!viewedList.length) return;

      const handlesToFetch = viewedList.slice(0, rvLimit);
      Promise.all(
        handlesToFetch.map((handle) =>
          fetch(`/products/${handle}?view=card`)
            .then((res) => res.text())
            .then((html) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const card = doc.querySelector('.collection-tabs-card');
              return card
                ? `<div class="product-related-tabs__item swiper-slide" data-product-handle="${handle}">${card.outerHTML}</div>`
                : '';
            })
            .catch(() => '')
        )
      ).then((items) => {
        const validItems = items.filter(Boolean);
        if (!validItems.length) return;

        if (swipers['recently-viewed'].instance && !swipers['recently-viewed'].instance.destroyed) {
          swipers['recently-viewed'].instance.destroy(true, true);
          swipers['recently-viewed'].instance = null;
        }

        rvGrid.innerHTML = validItems.join('');
        if (root.querySelector('[data-related-tab="recently-viewed"].is-active')) {
          initSwiper(rvSwiperEl, swipers['recently-viewed']);
        }
      });
    };

    const onResize = () => {
      const active = root.querySelector('[data-related-tab].is-active');
      const key = active ? active.dataset.relatedTab : 'recently-viewed';
      if (key === 'recommendations') initSwiper(recSwiperEl, swipers.recommendations);
      if (key === 'recently-viewed') initSwiper(rvSwiperEl, swipers['recently-viewed']);
    };

    initSwiper(rvSwiperEl, swipers['recently-viewed']);
    loadRecommendations();
    loadRecentlyViewed();
    window.addEventListener('resize', onResize);
  };

  const mountAll = (scope = document) => {
    scope.querySelectorAll('[data-product-related-tabs]').forEach(mountSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountAll());
  } else {
    mountAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-product-related-tabs]');
    if (root) delete root.dataset.relatedTabsInit;
    mountAll(event.target);
  });
})();
